var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuizGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_776_54903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_776_54903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 9.25033C8.33178 9.25033 8.47518 9.18956 8.59671 9.06803C8.71824 8.94651 8.779 8.8031 8.779 8.63783C8.779 8.47255 8.71824 8.32915 8.59671 8.20762C8.47518 8.08609 8.33178 8.02533 8.1665 8.02533C8.00123 8.02533 7.85782 8.08609 7.7363 8.20762C7.61477 8.32915 7.554 8.47255 7.554 8.63783C7.554 8.8031 7.61477 8.94651 7.7363 9.06803C7.85782 9.18956 8.00123 9.25033 8.1665 9.25033ZM7.729 7.38366H8.604C8.604 7.10172 8.63317 6.89512 8.6915 6.76387C8.74984 6.63262 8.88595 6.46005 9.09984 6.24616C9.3915 5.95449 9.58595 5.71873 9.68317 5.53887C9.78039 5.35901 9.829 5.14755 9.829 4.90449C9.829 4.46699 9.67588 4.1097 9.36963 3.83262C9.06338 3.55553 8.66234 3.41699 8.1665 3.41699C7.76789 3.41699 7.42032 3.5288 7.1238 3.75241C6.82727 3.97602 6.62067 4.27255 6.504 4.64199L7.2915 4.96283C7.379 4.71977 7.4981 4.53748 7.6488 4.41595C7.79949 4.29442 7.97206 4.23366 8.1665 4.23366C8.39984 4.23366 8.58942 4.29928 8.73525 4.43053C8.88109 4.56178 8.954 4.73921 8.954 4.96283C8.954 5.09894 8.91512 5.22776 8.83734 5.34928C8.75956 5.47081 8.62345 5.62394 8.429 5.80866C8.10817 6.0906 7.9113 6.31178 7.83838 6.4722C7.76546 6.63262 7.729 6.93644 7.729 7.38366ZM4.6665 11.0003C4.34567 11.0003 4.07102 10.8861 3.84255 10.6576C3.61407 10.4291 3.49984 10.1545 3.49984 9.83366V2.83366C3.49984 2.51283 3.61407 2.23817 3.84255 2.0097C4.07102 1.78123 4.34567 1.66699 4.6665 1.66699H11.6665C11.9873 1.66699 12.262 1.78123 12.4905 2.0097C12.7189 2.23817 12.8332 2.51283 12.8332 2.83366V9.83366C12.8332 10.1545 12.7189 10.4291 12.4905 10.6576C12.262 10.8861 11.9873 11.0003 11.6665 11.0003H4.6665ZM2.33317 13.3337C2.01234 13.3337 1.73768 13.2194 1.50921 12.991C1.28074 12.7625 1.1665 12.4878 1.1665 12.167V4.00033H2.33317V12.167H10.4998V13.3337H2.33317Z",
    fill: "rgba(24, 52, 98, 0.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuizGrey);
export default __webpack_public_path__ + "static/media/icon_quiz_grey.141b1e2aef5e3b49798a18a0af1b73c5.svg";
export { ForwardRef as ReactComponent };